<template>
  <v-dialog v-model="imagesDialog" width="1000" @click:outside="$emit('product-image-selector-dialog', false)">
    <v-card width="1000">
      <v-card-title> EXHIBIT GALLARY </v-card-title>
      <v-card-text>
        <v-container fluid class="px-0">
          <v-row>
            <v-col
              v-for="(imageFile, index) in productImages"
              :key="index"
              justify-space-between
            >
              <v-card
                class="text-center"
                @mouseover="overlayPictureId = index"
                @mouseleave="overlayPictureId = null"
              >
                <v-img
                  :src="getFilePath(imageFile.file.url)"
                  aspect-ratio="1"
                  max-width="150"
                  max-height="200"
                  class="mx-auto"
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      />
                    </v-row>
                  </template>
                </v-img>
                <v-overlay absolute :value="overlayPictureId === index">
                  <v-btn color="primary" @click="selectPicture(imageFile)">
                    SELECT
                  </v-btn>
                </v-overlay>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import imageUtilsMixin from '@/mixins/image_utils'

export default {
  mixins: [imageUtilsMixin],
  props: {
    productImages: {
      type: Array,
      required: true
    },
    imagesDialog: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      page: 1,
      overlayPictureId: null
    }
  },
  methods: {
    selectPicture (imageFile) {
      this.$emit('update-product-gallary', imageFile)
      this.$emit('close-gallary-selecter')
    }
  }
}
</script>

<style scoped></style>
